import { Button } from '@/components/ui/button';
import { Hammer } from 'lucide-react';
import { useNotify, useRecordContext } from 'ra-core';
import { useNavigate } from 'react-router-dom';
import type { BoM } from '../types';

export const CreateWorkOrderButton = () => {
    const record = useRecordContext<BoM>();
    const navigate = useNavigate();
    const notify = useNotify();

    if (!record || record.status !== 'approved') return null;

    const checklist = Array.isArray(record.readiness_checklist) ? record.readiness_checklist : [];
    const isReady = checklist.length === 4; // Hardcoding here for the 4 items

    const handleCreateWO = () => {
        if (!isReady) {
            notify('Cannot create Work Order. Complete the Pre-Production Readiness checklist first.', { type: 'warning' });
            return;
        }

        navigate('/work_orders/create', {
            state: {
                record: {
                    project_id: record.project_id,
                    bom_id: record.id,
                    reference: `WO-from-BOM-${record.reference}`,
                }
            }
        });
    };

    return (
        <Button 
            onClick={handleCreateWO} 
            disabled={!isReady}
            className={isReady ? "bg-amber-600 hover:bg-amber-700 text-white" : "bg-slate-200 text-slate-400"}
        >
            <Hammer className="w-4 h-4 mr-2" />
            Create Work Order
        </Button>
    );
};
